import { DialogBodyStyles, DialogBodyTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system";
import { DialogBody } from "./dialog-body";
/**
 * The Fabric Dialog Body component.
 *
 * @public
 */
export const definition = DialogBody.compose({
    name: `${DesignSystem.prefix}-dialog-body`,
    template: DialogBodyTemplate,
    styles: DialogBodyStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=dialog-body.definition.js.map